import React from "react";
import { Nav } from "shards-react";

import UserActions from "./UserActions";

const NavbarNav = () => {
  return (
    <Nav navbar className="border-left flex-row">
      {/* <Notifications /> */}
      <UserActions />
    </Nav>
  );
};

export default NavbarNav;
